import { render, staticRenderFns } from "./assetCloud.vue?vue&type=template&id=cef0ed5a&scoped=true&"
import script from "./assetCloud.vue?vue&type=script&lang=js&"
export * from "./assetCloud.vue?vue&type=script&lang=js&"
import style0 from "./assetCloud.vue?vue&type=style&index=0&id=cef0ed5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef0ed5a",
  null
  
)

export default component.exports